export const purchasePlanDialogue = {
    PerUse: 'Please enter the number of job posts you would like to purchase.',
    Professional: 'To proceed with purchasing the Professional Plan, our sales team will be in touch with you via email shortly.',
    Standard: 'To proceed with purchasing the Standard Plan, our sales team will be in touch with you via email shortly.',
    Enterprise: 'To proceed with purchasing the Enterprise Plan, our sales team will be in touch with you via email shortly.',
    ChangePlan: 'To change the plan, please contact the sales team, our sales team will be in touch with you via email shortly.'
};

export const SubscriptionPlans = {
    freetrial: 'Free trial',
    standard_monthly: 'Standard / Monthly',
    standard_annual: 'Standard / Annual',
    professional_monthly: 'Professional / Monthly',
    professional_annual: 'Professional / Annual',
    standard_monthly_1m: 'Standard / Monthly + 1 Member',
    standard_monthly_2m: 'Standard / Monthly + 2 Members',
    standard_monthly_3m: 'Standard / Monthly + 3 Members',
    standard_monthly_4m: 'Standard / Monthly + 4 Members',
    standard_monthly_5m: 'Standard / Monthly + 5 Members',
    standard_annual_1m: 'Standard / Annual + 1 Member',
    standard_annual_2m: 'Standard / Annual + 2 Members',
    standard_annual_3m: 'Standard / Annual + 3 Members',
    standard_annual_4m: 'Standard / Annual + 4 Members',
    standard_annual_5m: 'Standard / Annual + 5 Members',
    professional_monthly_1m: 'Professional / Monthly + 1 Member',
    professional_monthly_2m: 'Professional / Monthly + 2 Members',
    professional_monthly_3m: 'Professional / Monthly + 3 Members',
    professional_monthly_4m: 'Professional / Monthly + 4 Members',
    professional_monthly_5m: 'Professional / Monthly + 5 Members',
    professional_annual_1m: 'Professional / Annual + 1 Member',
    professional_annual_2m: 'Professional / Annual + 2 Members',
    professional_annual_3m: 'Professional / Annual + 3 Members',
    professional_annual_4m: 'Professional / Annual + 4 Members',
    professional_annual_5m: 'Professional / Annual + 5 Members',
};

export const creditCardExpirationYear = [
    {
        id: '1',
        title: '2024',
    },
    {
        id: '2',
        title: '2025',
    },
    {
        id: '3',
        title: '2026',
    },
    {
        id: '4',
        title: '2027',
    },
    {
        id: '5',
        title: '2028',
    },
    {
        id: '6',
        title: '2029',
    },
];

export const creditCardExpirationMonth = [
    {
        id: '1',
        title: '01',
    },
    {
        id: '2',
        title: '02',
    },
    {
        id: '3',
        title: '03',
    },
    {
        id: '4',
        title: '04',
    },
    {
        id: '5',
        title: '05',
    },
    {
        id: '6',
        title: '06',
    },
    {
        id: '7',
        title: '07',
    },
    {
        id: '8',
        title: '08',
    },
    {
        id: '9',
        title: '09',
    },
    {
        id: '10',
        title: '10',
    },
    {
        id: '11',
        title: '11',
    },
    {
        id: '12',
        title: '12',
    },
];

export const accountPlans = {
    monthly: [
        {
            id: 'basic',
            icon: 'flag',
            name: 'Basic',
            price: 'Free',
            per: '',
            slogan: 'Empower your recruitment journey with our free plan.',
            active: false,
            finalPrice: 0,
            totalJobCount: 1,
            seatCount: 1,
            seatBasePrice: 0,
            totalApplicantCount: 2,
            monthCount: 0,
            checkList: [
                '1 Job posting, up to 2 applicants',
                '1 user account seat',
            ]
        },
        {
            id: 'standard_monthly',
            icon: 'target',
            name: 'Standard',
            price: '$119',
            per: 'per month',
            slogan: 'Unleash the power of your business with the standard plan.',
            active: true,
            finalPrice: 119,
            totalJobCount: 2,
            seatCount: 1,
            monthCount: 1,
            seatBasePrice: 20,
            totalApplicantCount: 100,
            checkList: [
                '2 Job postings, up to 100 applicants / per month',
                '1 user account seat',
                'Customer support agent',
            ]
        },
        {
            id: 'professional_monthly',
            icon: 'gem',
            name: 'Pro',
            price: '$219',
            per: 'per month',
            slogan: 'Take your business to the next level with the business plan.',
            active: true,
            finalPrice: 219,
            totalJobCount: 5,
            seatCount: 2,
            monthCount: 1,
            seatBasePrice: 20,
            totalApplicantCount: 300,
            checkList: [
                '5 job postings, up to 300 applicants / per month',
                '2 user account seats',
                'Customer support agent',
            ]
        },
    ],
    yearly: [
        {
            id: 'basic',
            icon: 'flag',
            name: 'Basic',
            price: 'Free',
            per: '',
            slogan: 'Empower your recruitment journey with our free plan.',
            active: false,
            finalPrice: 0,
            totalJobCount: 1,
            seatCount: 1,
            monthCount: 0,
            seatBasePrice: 0,
            totalApplicantCount: 2,
            checkList: [
                '1 Job posting, up to 2 applicants',
                '1 user account seat',
            ]
        },
        {
            id: 'standard_annual',
            icon: 'target',
            name: 'Standard',
            price: '$99',
            per: 'per month',
            slogan: 'Unleash the power of your business with the standard plan.',
            active: true,
            finalPrice: 1188,
            totalJobCount: 24,
            seatCount: 1,
            monthCount: 12,
            seatBasePrice: 16,
            totalApplicantCount: 1200,
            checkList: [
                '2 Job postings, up to 100 applicants / per month',
                '1 user account seat',
                'Customer support agent',
            ]
        },
        {
            id: 'professional_annual',
            icon: 'gem',
            name: 'Pro',
            price: '$179',
            per: 'per month',
            slogan: 'Take your business to the next level with the business plan.',
            active: true,
            finalPrice: 2148,
            totalJobCount: 60,
            seatCount: 2,
            monthCount: 12,
            seatBasePrice: 16,
            totalApplicantCount: 3600,
            checkList: [
                '5 job postings, up to 300 applicants / per month',
                '2 user account seats',
                'Customer support agent',
            ]
        },
    ]
};
